"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Opportunity = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 15, height: 3, x: 4.5, y: 18, opacity: 0.6, rx: 0.5 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M12.855 6.809a2 2 0 10-1.71 0 .4.4 0 00-.027.052C10.384 8.556 9.108 10.473 7 11c-1.196.299-2.428-.183-3.37-.749a.516.516 0 00-.05-.026 2 2 0 10-.98.683.482.482 0 00.014.058l1.776 5.683a.5.5 0 00.478.351h14.264a.5.5 0 00.478-.35l1.776-5.684a.5.5 0 00.014-.058 2 2 0 10-.98-.683.507.507 0 00-.05.026c-.942.566-2.174 1.048-3.37.749-2.109-.527-3.384-2.444-4.118-4.14a.4.4 0 00-.027-.051z",
        clipRule: "evenodd"
      }
    )
  );
};
export default Opportunity;
